/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

require('whatwg-fetch');
const makeLocalUrl = require('@webex/test-helper-make-local-url');

/* eslint-env browser */

module.exports = function createUser(options) {
  return fetch(makeLocalUrl('/jwt'), {
    method: 'POST',
    headers: new Headers({
      'content-type': 'application/json',
    }),
    body: JSON.stringify(options),
  })
    .then((res) => res.json())
    .then((body) => body.jwt);
};
